import { State } from "../../core/src/states/State";
import ViewManager from "../../core/src/utils/ViewManager";
import { DefaultLayers } from "../../core/src/utils/Layers";
import SceneView from "../../core/src/views/SceneView";
import PointerEvents from "../../core/src/const/PointerEvents";
import CommandManager from "../../core/src/commands/CommandManager";
import { VendorCommandsEnum } from "../../src/commands/VendorCommandsEnum";
import Locale from "../../core/src/utils/Locale";
import VendorModel from "../../src/model/VendorModel";
import { IFreeGamesBetOption } from "../../src/model/IFreeGamesVendorData";
import BetModel from "../../core/src/model/BetModel";
import UIController from "../../core/src/ui/UIController";
import { UIModes, UIStates } from "../../core/src/ui/UIStates";
import SwitchButton from "../../core/src/views/components/SwitchButton";
import AutoplayModel from "../../core/src/model/AutoplayModel";
import { UIUpdateEvent } from "../../core/src/ui/UIUpdateEvents";
import ConsoleUtil from '../../core/src/utils/ConsoleUtil';
import { Commands } from '../../core/src/commands/CommandEnum';
import { Tween } from "../../core/src/Tween";
import App from "../../core/src/App";
import CurrencyUtils from "../../core/src/utils/CurrencyUtils";
import LocalStorageVars from "../../core/src/const/LocalStorageVars";
import LocalData from "../../core/src/utils/LocalData";
import SpinModel from "../../core/src/model/SpinModel";
import StateMachine from "../../core/src/states/StateMachine";
import { DefaultStates } from "../../core/src/states/DefaultStates";
import { UIComponents } from "../../core/src/ui/UIComponents";
import Configs from "../vendorConfigs/Configs";
import ButtonUtils from "../../core/src/utils/ButtonUtils";
import SwitchGroup from "../../core/src/views/components/SwitchGroup";
import TextField from "../../core/src/views/components/TextField";

const LOG_COLOR = 0xf59b42;

export default class FreeGamesAwardedState extends State {
    protected scene: SceneView;
    protected selectedVal: number;
    protected expiredDelayExit: Tween;


    protected highlightSelectedButton() {
        let btnGroup = this.scene.buttonGroups.get("choice");
        Tween.delayedCall(0.1, () => {
            btnGroup.getChildren().forEach((btn) => {
                btn.text.style.fill = App.config.betBtnLblStatesColor.out;
                if (btn.isSelected()) {
                    btn.text.style.fill = App.config.betBtnLblStatesColor.down;
                }
            });
        });
    }
    enter() {
        super.enter();
        UIController.setState(UIStates.IDLE);

        // this.scene:SceneView;
        if (
            VendorModel.freeGames.betSizeOptions &&
            VendorModel.freeGames.betSizeOptions.length
        ) {
            this.scene = ViewManager.getLayer(DefaultLayers.Popups).setScene(
                "freeGamesAwardedMultyChoice"
            );
            this.scene.interactive = true;
            let btnGroup = this.scene.buttonGroups.get("choice");
            this.scene.buttons.get("play").setEnabled(false);
            btnGroup.getChildren().forEach((btn) => {
                btn.setVisible(false);
            });
            VendorModel.freeGames.betSizeOptions.forEach((value, index) => {
                let btn = this.scene.buttons.get(
                    "choice~" + (index + 1)
                ) as SwitchButton;
                // In case PSD has such button we set its visibility and value.
                btn?.setVisible(true);
                // btn["bet"] = value.ba;
                let msgPatternReplace = [];
                msgPatternReplace.push(
                    value.spins,
                    CurrencyUtils.formatCurrency(
                        value.ba / App.config.subUnits,
                        BetModel.currencyLocalization
                    )
                );
                let text = Locale.getString(
                    "gui_free_games_data",
                    msgPatternReplace
                );
                btn?.setValue(JSON.stringify(value), text);
            });

            if (this.scene.sceneTextFields.has("text")) {
                this.scene.sceneTextFields.get("text").text = Locale.getString("");
            }
            btnGroup.onSelect((val: string) => {
                let valObj: IFreeGamesBetOption = JSON.parse(val);
                this.selectedVal = valObj.ba;
                VendorModel.freeGames.spins = valObj.spins;
                VendorModel.freeGames.ba = valObj.ba;
                //----save last bet before FG change it----
                LocalData.saveValue(LocalStorageVars.LAST_BET, BetModel.coinSizeIndex);
                //-----------------------------------------
                ///// VendorModel.freeGamesBet = VendorModel.freeGames.ba;
                ViewManager.getLayer(DefaultLayers.BetBar)
                    .setScene().sceneMoneyFields.get(UIComponents.TotalBetAlternative)
                    .value = VendorModel.freeGames.ba;

                //// CommandManager.execute(Commands.SAVE_SETTINGS);

                if (App.config.betBtnLblStatesColor) {
                   this.highlightSelectedButton();
                }
                
                this.scene.buttons.get("play").setEnabled(true);
            });
        } else {
            this.scene = ViewManager.getLayer(DefaultLayers.Popups).setScene(
                "freeGamesAwarded"
            );
            let msgPatternReplace = [];
            msgPatternReplace.push(
                VendorModel.freeGames.spins,
                CurrencyUtils.formatCurrency(
                    VendorModel.freeGames.ba / App.config.subUnits,
                    BetModel.currencyLocalization
                )
            );
            this.scene.sceneTextFields.get("text").text = Locale.getString(
                "gui_free_games_data",
                msgPatternReplace
            );

            ViewManager.getLayer(DefaultLayers.BetBar)
                .setScene().sceneMoneyFields.get(UIComponents.TotalBetAlternative)
                .value = VendorModel.freeGames.ba;
        }
        this.scene.sceneTextFields.get("title").text = Locale.getString(
            "gui_congratulations"
        );
        ViewManager.getLayer("SplashOverlay").setScene("open");
       /// BetModel.setStake(null, VendorModel.freeGames.ba);
        this.scene.buttons.get("play").on(PointerEvents.DOWN, () => {
            CommandManager.execute(Commands.CLEAR_AUTOPLAY_LIMITS)
            // if(VendorModel.freeGames.betSizeOptions) {

            // }
            SpinModel.enterFreegames();
            UIController.setMode(UIModes.PROMOTION_SPINS);
            UIController.setState(UIStates.IDLE);
            UIController.updateFields(UIUpdateEvent.FreeGames);
            CommandManager.execute(Commands.UPDATE_WIN, VendorModel.freeGames);
            // if(VendorModel.freeGames.betSizeOptions) {
            //     this.scene = ViewManager.getLayer(DefaultLayers.Popups).setScene("freeGamesAwardedMultyChoice");
            //     // let btnGroup = this.scene.buttonGroups.get("choice");
            //     // btnGroup.
            //     VendorModel.freeGames.ba = this.selectedVal;
            // }
            if (VendorModel.freeGames.autoplay &&
                !Configs.game.clientConfig.autoplayDisable) 
            {
                AutoplayModel.setAutoSpin(VendorModel.freeGames.spins);
                AutoplayModel.startAutoSpin();
            }
            let fg_scene = ViewManager.getLayer(DefaultLayers.FreegamesCounter).setScene("open");


            let counter = fg_scene.sceneTextFields.get("fg_counter");
            counter.text = VendorModel.freeGames.spins + "/" + 
                (VendorModel.freeGames.spins + VendorModel.freeGames.spinsPlayed)

            // imsFreespins is special for BET 365
            // https://docs.relax-gaming.com/partners/portal/operator-integrations#bet365 
            if (!VendorModel.freeGames.imsFreespins) {
                fg_scene.buttons.get("cancel_fg").setEnabled(!(SpinModel.hasFreespinsWon() || SpinModel.isInFreespins()));
                fg_scene.buttons.get("cancel_fg").once(PointerEvents.DOWN, () => {
                    if (SpinModel.isInFreespins()) {
                        this.exit();
                        return;
                    }
    
                    while(AutoplayModel.getAutoSpinNum()) {
                        AutoplayModel.decrementAutoSpinNum();
                    }
                    VendorModel.freeGames.spins = 0;
                    if(VendorModel.freeGames.autoplay && 
                       StateMachine.currentState.name == DefaultStates.Idle) {
    
                        CommandManager.execute(Commands.SKIP);
                    }
    
                    CommandManager.execute(Commands.UPDATE_WIN, VendorModel.freeGames);
                    CommandManager.execute(VendorCommandsEnum.CANCEL_FREE_GAMES);
                });
            }

            this.exit();
        });

        // imsFreespins is special for BET 365
        // https://docs.relax-gaming.com/partners/portal/operator-integrations#bet365 
        if (!VendorModel.freeGames.imsFreespins) {
            this.scene.buttons.get("fg_cancel").on(PointerEvents.DOWN, () => {
                CommandManager.execute(VendorCommandsEnum.CANCEL_FREE_GAMES);
                this.exit();
            });
        } else {
            this.scene.buttons.get("fg_cancel").visible = false;
        }

        this.scene.buttons.get("skip").on(PointerEvents.DOWN, () => {
            CommandManager.execute(VendorCommandsEnum.SKIP_FREE_GAMES);
            ViewManager.getLayer(DefaultLayers.BetBar)
                .setScene().sceneMoneyFields.get(UIComponents.TotalBetAlternative)
                .value = BetModel.totalBet;
            
            this.exit();
        });

        // Set timer for expire
        if (VendorModel.freeGames.expires) {
            let msRemaining =
                new Date(VendorModel.freeGames.expires * 1000).getTime() -
                new Date().getTime();

            ConsoleUtil.logWithColor(
                "[FreeGamesAwarded] Expire time: ",
                LOG_COLOR,
                new Date(VendorModel.freeGames.expires * 1000)
            );
            ConsoleUtil.logWithColor(
                "[FreeGamesAwarded] Time remaining: " + Math.round(msRemaining / 1000) + " seconds",
                LOG_COLOR
            );

            if (msRemaining <= 0) {
                this.exit();
            } else {
                this.expiredDelayExit = Tween.delayedCall((msRemaining / 1000) + 3, () => {
                    SpinModel.enterFreegames();
                    this.exit();
                }, [], this);
            }
        }

        ButtonUtils.fontSizeUnificationLabel(this.scene.buttons);
    }

    exit() {
        if (this.expiredDelayExit) {
            this.expiredDelayExit.kill();
        }
        // TweenMax.killDelayedCallsTo(this.exit);

        ViewManager.getLayer(DefaultLayers.Popups).clear();
        ViewManager.getLayer("SplashOverlay").clear();
        super.exit();
    }
}
